import { confirmAppUserIdentity } from '../app/authLogin';
import { getBiometricAvailability, verifyDeviceIdentity } from './authSession';

export type RouteIdentityLabels = {
  reason: string;
  title: string;
};

/**
 * Confirms runner identity when the screen returns after being turned off during route nav.
 * Tries device biometrics first, then password via {@link confirmAppUserIdentity}.
 */
export async function confirmRouteIdentity(
  username: string,
  password: string | null,
  labels: RouteIdentityLabels,
): Promise<{ ok: boolean; needsPassword: boolean }> {
  const availability = await getBiometricAvailability();
  if (availability.available) {
    const ok = await verifyDeviceIdentity(labels.reason, labels.title);
    if (ok) return { ok: true, needsPassword: false };
  }

  if (password == null) {
    return { ok: false, needsPassword: true };
  }

  const ok = await confirmAppUserIdentity(username, password);
  return { ok, needsPassword: !ok };
}
